export default __webpack_public_path__ + "static/media/dfdb71bd0df0b46243b0ae2b45fefb271581620482404.3c8ff8fd.webp";